<template>
  <!--
    PoolaFestivalLivePill — the "🔥 {n} عضو بيحجزوا دلوقتي" live social-proof pill
    (festival P2-B). HONESTY: {n} must be a REAL counter. There is NO polled
    source for a "right now / last hour" window on meta.festival today (only a
    run-total collectivePurchaseCount, which is NOT a live window) — so this pill
    HIDES until a real windowed count is fed. P3-A derives that count from a
    rolling window of `.PoolaOfferClaimed` realtime events and passes it as
    `count`. Until then the surface renders nothing (never a fabricated number).
  -->
  <span v-if="count != null && count > 0" class="poola-live-pill">
    {{ t(labelKey, { n: formatCount(count) }) }}
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  // The real windowed member count (null = no source yet → hide). Never faked.
  count: {
    type: Number,
    default: null,
  },
  // 'now' → «{n} عضو بيحجزوا دلوقتي»; 'lastHour' → «{n} عضو حجزوا في الساعة اللي فاتت».
  mode: {
    type: String,
    default: 'now',
    validator: (v) => ['now', 'lastHour'].includes(v),
  },
});

const { t } = useI18n({ useScope: 'global' });

const labelKey = computed(() =>
  props.mode === 'lastHour'
    ? 'poola.festival.live.claimedLastHour'
    : 'poola.festival.live.claimingNow',
);

// Western digits (owner-locked), grouped — never Arabic-Indic numerals.
const counter = new Intl.NumberFormat('en-US');
function formatCount(n) {
  return counter.format(n);
}
</script>

<style scoped>
.poola-live-pill {
  display: inline-block;
  padding: 4px 12px;
  border-radius: var(--poolit-radius-full);
  background: var(--poolit-primary-100);
  color: var(--poolit-primary-700);
  font-size: var(--poolit-font-size-caption);
  font-weight: var(--poolit-font-weight-semibold);
}
</style>
